export function Settings() {
  return (
    <div className="space-y-6">
      <div className="rounded-lg border border-border bg-card p-6">
        <h3 className="mb-4 text-lg font-semibold text-foreground">Settings</h3>
        <p className="text-sm text-muted-foreground">
          Configure your admin dashboard settings here.
        </p>
      </div>

      <div className="rounded-lg border border-border bg-card p-6">
        <h4 className="mb-2 font-medium text-foreground">Application Settings</h4>
        <p className="text-sm text-muted-foreground">
          Settings page placeholder. Add your configuration options here.
        </p>
      </div>
    </div>
  );
}
